import { CustomComponent, TOOL_TYPES } from "./ImproveChat.model";
import { ToolCard } from "./ToolCard";

type ComponentRenderer<T = any> = (data: T, isDisabled?: boolean) => JSX.Element | null;

const componentRenderers: Record<string, ComponentRenderer> = {
  "tool-display": (data, isDisabled) => (
    <ToolCard toolName={data.toolName} args={data.args} isDisabled={isDisabled} />
  ),
};

export function renderCustomComponent(
  component: CustomComponent,
  isDisabled?: boolean
): JSX.Element | null {
  const renderer = componentRenderers[component.type];
  if (!renderer) {
    console.warn(`No renderer found for component type: ${component.type}`);
    return null;
  }

  try {
    return renderer(component.data, isDisabled);
  } catch (error) {
    console.error(`Error rendering component type ${component.type}:`, error);
    return null;
  }
}

export function isToolComponent(toolName: string): boolean {
  return Object.values(TOOL_TYPES).includes(toolName as any);
}
